import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

const ClientRow = props => {
  const [phone, setPhone] = useState()

  useEffect(() => {
    if (props.client) setPhone(formattedPhone(props.client))
  }, [props.client.phone])

  const formattedPhone = (client) => {
    return client.country_code && client.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(client.phone) : formatPhoneNumber(client.phone)
  }

  return (
    <tr>
      <td onClick={props.onClick}>{props.client.name}</td>
      <td>{phone}</td>
      <td>{props.client.locations_names.length > 1 ? 'Multiple' : props.client.locations_names[0]}</td>
      <td>{props.client.last_date_played ? moment(props.client.last_date_played).format('DD/MM/YYYY') : ''}</td>
    </tr>
  )
}

export default ClientRow
